<template>
  <div>
    <el-card shadow="never" style="margin-bottom: 15px">
      <div class="d-flex align-items-center" style="overflow: hidden">
        <div class="header-wrapper">
          <div class="header-icon" />
        </div>
        <div class="flex-1 ml-2">
          <h5 style="color: #101010" v-if="!baseInfo.dfDefinitionName">
            {{ '新增标准' }}
          </h5>
          <h5 v-else style="color: #101010">
            {{ baseInfo.customerCode == 'ALL' ? 'ALL' : baseInfo.custName }}/{{
              baseInfo.dfDefinitionName
            }}
          </h5>
          <p style="font-size: 14px; color: #6c6c6c" class="m-0 text-truncate">
            <span> No：{{ baseInfo.dfDefinitionNo || '编号自动生成' }} </span>
            <el-divider direction="vertical" />
            <el-tag
              size="mini"
              :type="
                baseInfo.dfDefinitionStatus === 'Y'
                  ? 'success'
                  : baseInfo.dfDefinitionStatus === 'D'
                  ? 'danger'
                  : ''
              "
            >
              {{ baseInfo.dfDefinitionStatusName || '新增' }}
            </el-tag>
            <el-divider direction="vertical" v-if="baseInfo.dfDefinitionCode" />
            <span v-if="baseInfo.dfDefinitionCode">
              Modify：{{ baseInfo.modifyByName || '--' }} at
              {{ baseInfo.modifyDate || '--' }}
            </span>
          </p>
        </div>
      </div>
    </el-card>

    <el-card shadow="never" class="info-card">
      <div class="switch-tabs_wrappers mb-4">
        <div class="switch-tabs">
          <div
            v-for="item in switchTabs"
            :key="item.value"
            class="switch-tabs_items"
            :class="{
              active: item.value === activeName,
              disabled: item.disabled,
            }"
            @click="!item.disabled ? (activeName = item.value) : () => {}"
          >
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>

      <div v-show="activeName === 'info'">
        <EditForm
          ref="editForm"
          :disabled="disabled"
          :dfDefinitionCode="dfDefinitionCode"
          @loaded="(d) => (baseInfo = d)"
        />

        <div class="d-flex justify-content-end mt-4" v-if="!disabled">
          <div>
            <el-button
              type="primary"
              size="small"
              @click="$refs.editForm.save()"
            >
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </div>
        </div>
      </div>
      <div v-if="activeName === 'category'">
        <Category :disabled="disabled" :dfDefinitionCode="dfDefinitionCode" />
      </div>
      <div v-if="activeName === 'defectSeverity'">
        <DefectSeverity
          :disabled="disabled"
          :dfDefinitionCode="dfDefinitionCode"
        />
      </div>
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import Category from '../components/category'
import DefectSeverity from '../components/defect-severity'
export default {
  name: 'inspection-defects-detail',
  components: { EditForm, Category, DefectSeverity },
  data() {
    return { baseInfo: {}, activeName: 'info' }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
    dfDefinitionCode() {
      return this.params.code
    },
    switchTabs() {
      return [
        {
          label: '基本信息',
          value: 'info',
        },
        {
          label: this.$l('switchTabs_label_category') || '分类定义',
          value: 'category',
          disabled: !this.dfDefinitionCode,
        },
        {
          label:
            this.$l('switchTabs_label_defectSeverity') || '标准分类明细定义',
          value: 'defectSeverity',
          disabled: !this.dfDefinitionCode,
        },
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
.header-wrapper {
  width: 60px;
  height: 60px;
  min-width: 60px;
  background-image: url('./polygonal.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  display: flex;
  align-items: center;
  justify-content: center;
  .header-icon {
    width: 30px;
    height: 30px;
    background-image: url('./document.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
}

.switch-tabs {
  display: flex;
  .switch-tabs_items {
    padding: 20px 4px 16px;
    color: #6c757d;
    font-size: 14px;
    margin-right: 35px;
    cursor: pointer;
    min-width: max-content;
  }
  .switch-tabs_items:hover,
  .switch-tabs_items.active {
    color: #007bff;
    border-bottom: 3px solid #1989fa;
  }
  .switch-tabs_items.disabled {
    cursor: no-drop;
  }
  .switch-tabs_items.disabled:hover {
    color: #8cc5ff;
    border-bottom: 3px solid #8cc5ff;
  }
  .switch-tabs_items:last-child {
    margin-right: 0;
  }
}

::v-deep {
  .info-card .el-card__body {
    padding-top: 0;
  }
}
</style>
